import FilterItem from '../FilterItem';

const STRATEGY_TYPES = ['or', 'and'];

class FilterMultiStrategy extends FilterItem {
  constructor(conf, subcategory) {
    super(conf, subcategory);
    this.value = FilterMultiStrategy.getEmptyValue();
  }

  static getEmptyValue() {
    return { or: [], and: [] };
  }

  async apply(_, valuesMap = {}) {
    const value = FilterMultiStrategy.getEmptyValue();

    for (const key in valuesMap) {
      const rawValue = valuesMap[key];
      const normalizedValue = Array.isArray(rawValue) ? rawValue.filter(Boolean) : [rawValue].filter(Boolean);

      if (key.includes('and')) {
        value.and = normalizedValue;
      }
      if (key.includes('or')) {
        value.or = normalizedValue;
      }
    }

    this.value = value;
    this.dispatchEvent({ type: 'updateValue', value });
  }

  resetValue = () => {
    this.value = FilterMultiStrategy.getEmptyValue();
  };

  collectValues() {
    const types = Object.keys(this.value);
    let filter = {};
    for (let t of types) {
      const rawValues = Array.isArray(this.value[t]) ? this.value[t] : [this.value[t]];
      const values = rawValues.filter(Boolean);
      filter[`${this.property}${`[${t}]`}`] = values;
    }
    return filter;
  }

  getStrategyGroups(value) {
    return STRATEGY_TYPES.map((type) => ({
      type,
      values: (value?.[type] || []).filter(Boolean),
    })).filter((group) => group.values.length > 0);
  }

  getStrategyString(value) {
    const groups = this.getStrategyGroups(value);
    return groups
      .map(({ type, values }) => {
        const body = values.join(` ${type.toUpperCase()} `);
        // Only the OR alternatives need to be fenced off from the AND terms next to them.
        return FilterMultiStrategy.needsParentheses(groups, type, values) ? `(${body})` : body;
      })
      .join(' AND ');
  }

  static needsParentheses(groups, type, values) {
    return groups.length > 1 && type === 'or' && values.length > 1;
  }
}

export { STRATEGY_TYPES };
export default FilterMultiStrategy;
